import { QueryReturnValue } from '@reduxjs/toolkit/dist/query';

export async function queryUntilLastPage<T>(args: QueryUntilLastPageArgs): Promise<QueryReturnValue<T[]>> {
  const { baseQuery, url, params: initParams = {} } = args;

  const params = new URLSearchParams(initParams);

  const result: T[] = [];

  let last = false;
  let page = 0;

  while (!last) {
    params.set('page', `${page}`);

    const response = await baseQuery({ url, params });

    if (response.error) return { error: response.error };

    const data = response.data;

    if (data.last === undefined) break;

    result.push(...data.content);

    last = data.last;
    page++;
  }

  return { data: result };
}


interface QueryUntilLastPageArgs {
  baseQuery: any;
  url: string;
  params?: URLSearchParams | Record<string, string>;
}